import * as yup from "yup";
const PHONE_REGEX =
  /^\+?[1-9]\d{1,14}$/;

export const NoteSchema = yup.object().shape({
  notes: yup
    .string()
    .required("Notes are required")
    .min(5, "Notes should be at least 5 characters"),
});

export const patientInfoSchema = yup.object({
  first_name: yup.string().required("First name is required"),
  last_name: yup.string(),
  phone_number: yup
    .string()
    .matches(PHONE_REGEX, "Invalid phone number format"),
  email_address: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  backup_phone_number: yup
    .string()
    .matches(PHONE_REGEX, "Invalid phone number format"),
  country_of_residence: yup.string().required("Country is required"),
  preferred_contact_method: yup.string(),
  created_at: yup.string(),
  tags: yup.array().of(yup.string()),
  locations: yup.string(),
});

export const addReviewSchema = yup.object({
  providerId: yup.string().required("Provider is required"),
  name: yup
    .string()
    .matches(/^[A-Z]/, "Name must start with a capital letter")
    .required("Name is required"),
  rating: yup
    .number()
    .min(1, "Rating must be at least 1")
    .max(5, "Rating can be up to 5")
    .required("Rating is required"),
  reviews: yup.string().required("Review is required"),
});

export const importReviewSchema = yup.object({
  providerId: yup.string().required("Provider is required"),
  csvFile: yup
    .mixed()
    .required("CSV file is required")
    .test("fileType", "Only CSV files are allowed", (value) => {
      return value && value.type === "text/csv";
    }),
});

export const addTeamSchema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .required("Email is required")
    .email("Invalid email"),
    // .test(
    //   "is-lowercase",
    //   "Email must be in lowercase",
    //   (value) => !value || value === value.toLowerCase()
    // )
  phoneNumber: yup.string().required("Phone number is required"),
  userType: yup.string().required("User type is required"),
  doctorTitle: yup.string(),
});

export const addDisTeamSchema = yup.object({
  firstName: yup
    .string()
    .required("First Name is required")
    .test(
      "is-capitalized",
      "First letter of First Name must be capital",
      (value) => {
        return value && value[0] === value[0].toUpperCase();
      }
    ),
  lastName: yup
    .string()
    .required("Last Name is required")
    .test(
      "is-capitalized",
      "First letter of Last Name must be capital",
      (value) => {
        return value && value[0] === value[0].toUpperCase();
      }
    ),
  profileImg: yup
    .mixed()
    .nullable()
    .test(
      "fileSize",
      "File size should not be more than 1 MB",
      (value) => !value || (value && value.size <= 1024 * 1024)
    )
    .test(
      "fileType",
      "Unsupported File Format",
      (value) =>
        !value || (value && ["image/jpeg", "image/png"].includes(value.type))
    ),
  streetAddress: yup.string().required("Street Address is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  country: yup.string().required("Country is required"),
  zipCode: yup.string().required("ZipCode is required"),
  about_me: yup.string().required("About me is required"),
  insurance_details: yup.array(),
  // .of(
  //   yup.string()
  //     .required("Type can't be empty") // Each tag must be a non-empty string
  //     .min(2, 'Type is too short - should be at least 2 characters')
  //     .max(20, 'Type is too long - should be 20 characters or less')
  // )
  // .min(1, 'At least one Type is required')  // Require at least one tag
  // .max(10, 'You can only add up to 10 Type') // Op
});
